<template>
    <div class="news-headlines">
        <!-- <newsHeader :page="'头条新闻'"></newsHeader> -->
        <breadCrumb></breadCrumb>
        <router-view></router-view>
        <scorllTop></scorllTop>
        <!-- <footer-view></footer-view> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentPage:1,
            loadText:'加载更多',
            loadClass:true,
            lists:[],
        }
    },
    methods: {
        async getNewsList(){
            let that = this;
            let params = {
                clazz:1,
                isAsc:'desc',
                pageNum: this.currentPage++,
                pageSize: 7
            }            

            let resData = await Api.News.GetNewsList(params)
            // console.log(resData)

            params.pageNum = this.currentPage;
            let res = await Api.News.GetNewsList(params)
            if(res.rows.length < 1) {
                this.loadText = '加载已完成'
                this.loadClass = false;
            }
            
            that.lists = this.lists.concat(resData.rows);


            // that.clickGetList();
         },

         toDetail(id) {
             console.log(id);
             Common.goPage(`/news/headlines/detail/${id}`,this)
         }
    },
    mounted(){
        this.$nextTick(function(){
            this.getNewsList();
        })
        
    }
}
</script>

<style lang="less">
     @import "../less/news_common.less";
     @import "../less/news_headlines.less";
</style>